exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comp-card {\n  background-color: #ffffff;\n  font-size: 1rem;\n  border: 1px solid #bdbdbd; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/competition-list/competition-list.component.scss
// module id = ../../../../../src/app/component-module/competition-list/competition-list.component.scss
// module chunks = main